// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  OperatorApi,
  ServerConfiguration,
  createConfiguration,
  RegistryApi,
} from '@digitalasset/utility-operator-api-ts-client';
import React, { useMemo } from 'react';
import { UtilityOperatorApiContext } from './UtilityOperatorApiContext';
import { UtilityRegistryApiContext } from './UtilityRegistryApiContext';

interface UtilityOperatorApiProps {
  utilityOperatorUrl: string;
}

export const UtilityOperatorProxyApiProvider = ({
  utilityOperatorUrl,
  children,
}: React.PropsWithChildren<UtilityOperatorApiProps>) => {
  const configuration = createConfiguration({
    baseServer: new ServerConfiguration(utilityOperatorUrl, {}),
  });

  const operatorClient: OperatorApi | undefined = useMemo(() => {
    return new OperatorApi(configuration);
  }, [configuration]);

  const registryClient: RegistryApi | undefined = useMemo(() => {
    return new RegistryApi(configuration);
  }, [configuration]);

  return (
    <UtilityOperatorApiContext.Provider value={operatorClient}>
      <UtilityRegistryApiContext.Provider value={registryClient}>
        {children}
      </UtilityRegistryApiContext.Provider>
    </UtilityOperatorApiContext.Provider>
  );
};
